import { create } from 'zustand';
import { safeParseJSON } from '@/lib/utils/json-repair';

interface UserContextState {
  userContext: unknown;
  getUserContext: () => unknown;
  setUserContext: (userContext: unknown) => void;
  setUserContextFromString: (userContext: string) => void;
  clearUserContext: () => void;
  consumeUserContext: () => unknown;
}

export const useUserContextStore = create<UserContextState>((set, get) => ({
  userContext: undefined,
  getUserContext: () => get().userContext,
  setUserContext: (userContext) => set({ userContext }),
  setUserContextFromString: (userContext) => {
    set({ userContext: safeParseJSON(userContext) });
  },
  clearUserContext: () => set({ userContext: undefined }),
  consumeUserContext: () => {
    const userContext = get().userContext;

    if (userContext) {
      set({ userContext: undefined });
    }

    return userContext;
  },
}));
